module.exports = __webpack_public_path__ + "868ad8ac.png";